import { atom } from "recoil";
export const groupsAtoms = atom({
  key: "groupsAtoms", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
